import { createContext } from 'react';

export interface UserProfile {
  id: string;
  name?: string;
  username?: string;
  summary?: {
    contributions: {
      total_contributions: number;
      contributions_by_media_type: {
        text: number;
        audio: number;
        image: number;
        video: number;
        document: number;
      };
    };
    edits: {
      total_edits: number;
    };
    overall: {
      total_activities: number;
    };
  };
  total_contributions?: number;
  total_edits?: number;
  total_active_days?: number;
  uploads_today?: number;
  hours_active?: number;
  user_id?: string;
  user_name?: string;
}

export type AuthContextType = {
  token: string | null;
  user: UserProfile | null;
  login: (token: string, user: UserProfile) => Promise<UserProfile>;
  logout: () => void;
  isReady: boolean;
  refetchUser: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextType | null>(null);
